/* eslint-disable */
export default () => {
  String.prototype.hashCode = function () {
    var hash = 0, i, chr;
    if (this.length === 0) return hash;
    for (i = 0; i < this.length; i++) {
      chr = this.charCodeAt(i);
      hash = ((hash << 5) - hash) + chr;
      hash |= 0; // Convert to 32bit integer
    }
    return hash;
  }

  var UID = {
    _current: 0,
    getNew: function () {
      this._current++;
      return this._current;
    }
  };

  HTMLElement.prototype.pseudoStyle = function (element, prop, value) {
    var _this = this;
    var _sheetId = "pseudoStyles";
    var _head = document.head || document.getElementsByTagName('head')[0];
    var _sheet = document.getElementById(_sheetId) || document.createElement('style');
    _sheet.id = _sheetId;
    var className = "pseudoStyle" + UID.getNew();

    _this.className += " " + className;

    _sheet.innerHTML += "\n." + className + ":" + element + "{" + prop + ":" + value + "}";
    _head.appendChild(_sheet);
    return this;
  };
}

/**
 * Copy of existing set & get functions
 * */
// const _setItem = Storage.prototype.setItem;
// const _getItem = Storage.prototype.getItem;
/* eslint-enable */
/**
 * Rewrite storage value by key
 * @param {string} key
 * @param {*} value
 * @param {number} ttl - value in milliseconds to the current millisecond time
* */
/*
function setWithExpiry(key, value, ttl) {
  const now = new Date();
  const currYear = now.getFullYear();
  const defaultExpiry = new Date().setFullYear(parseInt(currYear, 10) + 2);

  // `item` is an object which contains the original value
  // as well as the time when it's supposed to expire
  const item = { value, expiry: ttl ? (now.getTime() + ttl) : defaultExpiry };
  _setItem.apply(this, [key, JSON.stringify(item)]);
}
 */
/**
 * Checks the expiry condition. If the item has, in-fact expired, we remove the key from localStorage.
 * @param {string} key
 * @return {*} - returns storage value or null depends on the expiry time
 * */
/*
function getWithExpiry(key) {
  const itemStr = _getItem.apply(this, [key]);
  let item;
  const now = new Date();
  // if the item doesn't exist, return null
  if (!itemStr) {
    return null;
  }
  // if the item doesn't fit new shape rewrites existing value
  try {
    item = JSON.parse(itemStr);
    if (!item.expiry) {
      throw new Error('old approach');
    }
  } catch (e) {
    this.setItem(key, itemStr);
    return itemStr;
  }

  // compare the expiry time of the item with the current time
  if (now.getTime() > item.expiry) {
    // If the item is expired, delete the item from storage
    // and return null
    this.removeItem(key);
    return null;
  }
  return item.value;
}
 */

/**
 * New local storage getter & setter functionality via re-defining methods
 * */
// localStorage.setItem = setWithExpiry;
// localStorage.getItem = getWithExpiry;

